module.exports = __webpack_public_path__ + "img/AB2C2C_EBB4B3_561212_DE8484-256px.3fe09ccb.png";